export const sortByTimestampDesc = (a, b) => {
    return (b.timestamp ? b.timestamp : 0) - (a.timestamp ? a.timestamp : 0);
};

export const sortOtherRoutesByStatusAndTimestamp = (otherRoutes) => {
    // Create a new array containing only the objects with type "OPEN" and sort by timestamp
    const openRoutes = otherRoutes
        .filter((route) => route.status === 'OPEN')
        .sort(sortByTimestampDesc);

    // Create a new array containing only the objects without type "OPEN" and sort by timestamp
    const routes = otherRoutes
        .filter((route) => route.status !== 'OPEN')
        .sort(sortByTimestampDesc);

    return openRoutes.concat(routes);
};
